export default __webpack_public_path__ + "static/media/1128.8f9cb11c.png";